export const REFERRALS_STRINGS = {
  'message.firstSentence': 'We have',
  'message.value': '$1,000',
  'message.secondSentence': 'that belongs in your\u00a0pocket!',
  cta: 'Refer',
};
